import React from "react"
import { Link, generatePath } from "react-router-dom"
import { ROUTES } from "../../../common/utils"
import { CloseIcon, PriceTagIcon } from "../../../common/Icons"
import { TickerInput } from "../../../common/FormFields"

function Item({
  product,
  currency,
  setProductQuantity,
  max,
  closeButtonAction,
  orderUUID,
  type,
  shipped
}) {
  function handleSetQuantity(quantity) {
    setProductQuantity(quantity, product.id)
  }

  function handleCloseButton() {
    closeButtonAction(product.id, type)
  }

  const total = Number(product.quantity) * Number(product.price)

  function getVariantName(variants) {
    if (variants.includes("default_option")) {
      return ""
    } else {
      return variants.join(", ")
    }
  }

  return (
    <div className="ProductItem">
      <div className="product-meta">
        <div>
          {(product.images &&
            product.images.length > 0 && (
              <div className="product-image">
                <img src={product.images[0]} alt={product.name} />
              </div>
            )) || (
            <div className="product-image-placeholder">
              <PriceTagIcon />
            </div>
          )}
          <div className="product-name">
            <span>
              <Link
                style={{ color: "#898989" }}
                to={{
                  pathname: generatePath(ROUTES.CHECKOUT_PRODUCT_DETAILS, {
                    product_id: product.id,
                    type: type
                  })
                }}
              >
                {product.name}
              </Link>
            </span>
            {product.variants && (
              <span>{getVariantName(product.variants)}</span>
            )}
          </div>
        </div>
        {!shipped && (
          <button type="button" onClick={handleCloseButton}>
            <CloseIcon />
          </button>
        )}
      </div>
      <div className="product-price">
        <div>
          <span>Unit Price</span>
          <span>
            {Number(product.price).toLocaleString("en", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}{" "}
            {currency}
          </span>
        </div>
        <div className="quantity">
          <span>Quantity</span>
          <span>
            <TickerInput
              min={type === "custom" ? parseInt(max) : parseInt(1)}
              max={parseInt(max)}
              value={parseInt(product.quantity)}
              setValue={handleSetQuantity}
              handleChange={handleSetQuantity}
              showMaxError={true}
              showMinError={true}
              maxError={
                type === "custom"
                  ? "Custom product quantity cannot be adjusted."
                  : null
              }
              minError={
                type === "custom"
                  ? "Custom product quantity cannot be adjusted."
                  : null
              }
              disabled={shipped}
            />
          </span>
        </div>
        <div>
          <span>Total Price</span>
          <span>
            {`${Number(total).toLocaleString("en", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} ${currency}`}
          </span>
        </div>
      </div>
    </div>
  )
}

export default Item
